import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _Number$isInteger from '@babel/runtime-corejs3/core-js-stable/number/is-integer';
import _Number$MAX_SAFE_INTEGER from '@babel/runtime-corejs3/core-js-stable/number/max-safe-integer';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { forwardRef, useRef, useMemo } from 'react';
import classNames from 'classnames';
import styles from './58fa1f07ab76fe84c9e4d2c411cd007cd60b7b4abeea917082422b73d3a79651.cfe-internal.js';
import usePaginationContext from './df75c05401804c6d8142b2bca56715be95f3ec399c9a77fd514147d01733223c.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../Input/8b306eed80472bc167488d029758903f189ea21b58685c7d85ad4a1de9637088.cfe-internal.js';
import Translate from '../../utils/Translation/875f0722d02bdc9edc484b2707ddaf23bbeecb311e10f6f73aba9dec1e2d2e78.cfe-internal.js';
import Input from '../Input/0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["data-testid", "aria-label", "aria-labelledby", "aria-describedby", "onChange", "onBlur", "onFocus", "className", "style"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Renders the PaginationPageInput.
 * Either `Pagination` renders this component automatically or the consumer renders this component explicitly.
 */
var PaginationPageInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTestIdFromProps = _ref['data-testid'],
    ariaLabelFromProps = _ref['aria-label'],
    ariaLabelledByFromProps = _ref['aria-labelledby'],
    ariaDescribedByFromProps = _ref['aria-describedby'],
    _onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Element reference to the input
  var inputRef = useRef(null);

  // Context for Pagination
  var _usePaginationContext = usePaginationContext(),
    numPages = _usePaginationContext.numPages,
    pageInputValue = _usePaginationContext.pageInputValue,
    currentPage = _usePaginationContext.currentPage,
    dataTestId = _usePaginationContext.dataTestId,
    ariaLabel = _usePaginationContext.ariaLabel,
    ariaLabelledBy = _usePaginationContext.ariaLabelledBy,
    ariaDescribedBy = _usePaginationContext.ariaDescribedBy,
    handlePageChange = _usePaginationContext.handlePageChange,
    setPageInputValue = _usePaginationContext.setPageInputValue;

  /**
   * Computes the width of the input based on the number of characters entered
   */
  var inputWidth = useMemo(function () {
    var _currentPage$toString;
    var numDigits = (_currentPage$toString = currentPage === null || currentPage === void 0 ? void 0 : currentPage.toString().length) !== null && _currentPage$toString !== void 0 ? _currentPage$toString : 0;
    var minWidth = 36;
    return numDigits > 2 ? 9 * (numDigits - 2) + minWidth : minWidth;
  }, [currentPage]);

  /**
   * Sets the `pageInputValue` to `currentPage` if there is a discrepancy
   */
  var handleBlur = function handleBlur() {
    if (pageInputValue !== currentPage && currentPage !== undefined) {
      setPageInputValue === null || setPageInputValue === void 0 || setPageInputValue(currentPage);
    }
  };

  /**
   * Updates the `pageInputValue`.
   * Calls `handlePageChange` in order to call the `onPageChange` prop (only if the input is an integer).
   * @param {String | Number} newValue - The value entered into the input
   */
  var handleInputChange = function handleInputChange(newValue) {
    if (newValue === '' || !_Number$isInteger(Number(newValue))) {
      setPageInputValue === null || setPageInputValue === void 0 || setPageInputValue(newValue);
    } else {
      var newPage = Math.min(Math.max(1, newValue), numPages || _Number$MAX_SAFE_INTEGER);
      setPageInputValue === null || setPageInputValue === void 0 || setPageInputValue(newPage);
      handlePageChange === null || handlePageChange === void 0 || handlePageChange(newPage);
    }
  };

  /**
   * If there is a ref to the input, selects all text within the input
   */
  var handleFocus = function handleFocus() {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.select();
  };
  return /*#__PURE__*/React__default.createElement(Translate, {
    messageKey: "pagination",
    placeholders: {
      currentPage: /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
        "data-testid": dataTestIdFromProps || getSubDataTestId(dataTestId, 'PageInput'),
        ref: mergeRefs(ref, inputRef),
        key: "currentPage",
        "aria-label": ariaLabelFromProps || ariaLabel,
        "aria-labelledby": ariaLabelledByFromProps || ariaLabelledBy,
        "aria-describedby": ariaDescribedByFromProps || ariaDescribedBy,
        small: true,
        type: "number",
        min: 1,
        max: numPages,
        value: pageInputValue,
        onChange: function onChange(e) {
          _onChange === null || _onChange === void 0 || _onChange(e);
          handleInputChange(e.target.value);
        },
        onBlur: function onBlur(e) {
          _onBlur === null || _onBlur === void 0 || _onBlur(e);
          handleBlur();
        },
        onFocus: function onFocus(e) {
          _onFocus === null || _onFocus === void 0 || _onFocus(e);
          handleFocus();
        },
        style: _objectSpread(_objectSpread({}, style), {}, {
          width: inputWidth
        }),
        className: classNames(className, styles.input)
      })),
      numPages: numPages
    }
  });
});

export { PaginationPageInput as default };
